import React, {VoidFunctionComponent} from "react";
import {ScheduleItems} from "@/components/responsive/product/layer/credit/ScheduleItems";
import {Argument} from "@/components/responsive/product/layer/credit/Argument";
import {Document} from "@/components/responsive/product/layer/credit/Document";


export const CreditLayer: VoidFunctionComponent = () => {
    return (
        <div className='credit-layer' id="cetelemInfos">
            <div className='credit-top'>
                <img className='mascot' src={'/assets/images/responsive/cetelemMascot.png'} alt='mascotte Cetelem'/>
                <div className='text'>
                    <img className='slogan' src={'/assets/images/responsive/cetelem.png'} alt='slogan Cetelem'/>
                    <p className='bold'>
                        Réglez vos achats en <span className='greenCetelem'>4 fois</span>
                    </p>
                    <p>avec votre carte bancaire</p>
                </div>
                <img className='cb-4x' src={'/assets/images/responsive/cb4x.png'} alt='4 fois carte bancaire'/>
            </div>

            <div className='arguments-block'>
                <Argument
                    title='simple'
                    content='Faites votre shopping et choisissez de régler en 4X'
                />
                <Argument
                    title='rapide'
                    content='Saisissez vos coordonnées personelles et bancaires puis validez vos achats en quelques clics'
                />
                <Argument
                    title='sécurisé'
                    content='Vos achats sont réglés par prélèvement sur votre compte bancaire'
                />
            </div>

            <div className='cost-details'>
                <p className='category-title'>Simulation de votre financement</p>
                <div className='content'>
                    <div className='details'>
                        <p className='label'>Montant du produit</p>
                        <p className='amount' id="moneyAmountProduct"></p>
                    </div>
                    <div className='details'>
                        <p className='label'>
                            Coût du financement
                            <br/>
                            (TAEG <span id="taeg"/>)
                        </p>
                        <p className='amount' id="moneyFee"></p>
                    </div>
                    <div className='details'>
                        <div className='label-tooltip'>
                            <p className='label'>Montant total</p>
                        </div>
                        <p className='amount' id="moneyAmountTotal"></p>
                    </div>
                </div>
            </div>

            <div className='schedule'>
                <p className='category-title'>Echéancier de paiement</p>
                <div className='content' id="#timelineNumber">
                    <ScheduleItems index={1} date={"firstDate"} amount={"firstAmount"} id="timelineNumber"/>
                    <ScheduleItems index={2} date={"secondDate"} amount={"secondAmount"} id="timelineNumber"/>
                    <ScheduleItems index={3} date={"thirdDate"} amount={"thirdAmount"} id="timelineNumber"/>
                    <ScheduleItems index={4} date={"fourthDate"} amount={"fourthAmount"} id="timelineNumber"
                                   isLinked={false}/>
                </div>
            </div>

            <div className='info'>
                <p className='category-title'>Pour en profiter, rien de plus simple !</p>
                <div className='content'>
                    <img src={'https://media.but.fr/Sources/responsive/Images/ProductSheet/creditCard.png'} alt='carte de crédit'/>
                    <ul className='list'>
                        <li>Votre carte bancaire</li>
                        <li>Votre téléphone portable</li>
                    </ul>
                </div>
                <p className='legal'>
                    Important : Les cartes etrangères, les cartes exclusivement de retrait
                    et les cartes à autorisation systématiques (Electron, Maestro,
                    Cirrus...) ne sont pas acceptées, ni les e-card.
                </p>
            </div>

            <div className='documents'>
                <p className='category-title'>
                    En cas de retrait de votre produit en magasin, il faudra présenter les
                    documents suivants :
                </p>
                <div className='block'>
                    <Document
                        title='Une piéce d’identité'
                        content='en cours de validité et à votre nom'
                        imageUrl={'/assets/images/responsive/svg/idCard.svg'}
                        imageAlt='carte identité'
                    />
                    <Document
                        title='Votre carte de paiement'
                        content='Ayant servi à régler la commande sur le site lors d’un paiement en 4X CB'
                        imageUrl={'/assets/images/responsive/svg/cbCard.svg'}
                        imageAlt='carte de crédit'
                    />
                    <Document
                        title='le mail de confirmation'
                        content='de réservation'
                        imageUrl={'/assets/images/responsive/svg/send.svg'}
                        imageAlt='envoi'
                    />
                </div>
            </div>

            <p className='legal'>
                Offre de paiement en 4 fois: facilité de paiement réservée aux porteurs
                d'une carte bancaire pour un achat compris entre 90 € et 3000 €. Versement
                comptant obligatoire par carte bancaire égal à 25 % du montant de l'achat
                et le solde en 3 mensualités égales, les frais de dossier correspondent à
                1,4 % du montant du panier (appelés sur la 1ère mensualité) dans un
                maximum de 12 €. Exemple pour un achat à régler de 200 € : 1er versement
                comptant de 54,20 € (dont 4,20 € de frais de dossier au moment de l'achat)
                suivi de 3 échéances mensuelles de 50 € chacune.Vous disposez d'un droit
                de rétractation. Coût total de l'opération: 204,20 €. Conditions en
                vigueur à partir du 01/06/2021.
            </p>

        </div>
    );
};
